import { Dictionary } from 'underscore';

import { AppState } from '../app/state/AppState';

import { ExplorableItemType } from '../ts/models/ContentType';
import { IContentInfo } from '../ts/models/IContentInfo';
import { IMetricDataInfo } from '../ts/models/IMetricInfo';
import { IMetricDataPoints } from '../ts/ServerApi/types/IMetricDataList';

import { Loadable, LoadingStatus } from './models/Loadable';
import { MetricsDataState } from './state/MetricsDataState';

export const getLoadableData = (state: MetricsDataState, id: string): Loadable<IMetricDataPoints> => {
  const model = state.dataPointsById[id];

  return model || Loadable.notLoaded;
};

export const getMetricsDataState = (state: AppState): MetricsDataState => {
  return state.metricsData;
};

const nonMetricData = {};

export function selectMetricDataForMetricId(state: AppState, id: string): IMetricDataInfo | undefined {
  const loadableContent = getLoadableData(getMetricsDataState(state), id);
  if (loadableContent.loadingStatus === LoadingStatus.LOADED) {
    return loadableContent.content;
  }

  return undefined;
}

export function selectMetricDataForContentItem(state: AppState, content: (IContentInfo<ExplorableItemType> | Dictionary<any>)): IMetricDataInfo | undefined {
  if (!content || content.contentType !== 'metric') {
    return nonMetricData;
  }

  return selectMetricDataForMetricId(state, content.id);
}

export const notLoadedData = (state: MetricsDataState, ids: ReadonlyArray<string>): ReadonlyArray<string> => {
  return ids
    .map(id => ({ id, loadable: getLoadableData(state, id)}))
    .filter(item => item.loadable.loadingStatus === LoadingStatus.NOT_LOADED)
    .map(item => item.id);
};
